import {IInsuranceFamily} from "@/model/InsuranceFamily/InsuranceFamily"
import GlobalInsuranceFamily from "@/model/InsuranceFamily/GlobalInsuranceFamily"
import ParticipantInsuranceFamily from "@/model/InsuranceFamily/ParticipantInsuranceFamily"

export interface IInsuranceFamilyFactory {

}

class InsuranceFamilyFactory implements IInsuranceFamilyFactory {

    // constructor() {
    // }

    public static createInsuranceFamily(familyId: string): IInsuranceFamily {
        // return specific service families based on id
        switch (familyId) {
            case '1': return new ParticipantInsuranceFamily(familyId)
            case '3': return new GlobalInsuranceFamily(familyId)
            default: throw new Error(`insurance with id "${familyId}" is not supported`)
        }
    }
}

export default InsuranceFamilyFactory